import { t } from "i18next";
import { Button, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Athlete, AthleteRanking, emptyAthlete } from "../../../../interfaces/athlete";
import { createAthleteRanking, deleteAthleteRanking, getAthleteRanking, getAthleteSingle } from "../../../../services/athlete";
import { Media } from "../../../../interfaces/media";
import DataTable from "react-data-table-component";
import moment from "moment";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { tableStyles, getPaginationOptions } from "../../../../util/data-table";

interface AdminAthleteRankingProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminAthleteRanking(props: AdminAthleteRankingProps) {
    const [athlete, setAthlete] = useState<Athlete>(emptyAthlete);
    const [media, setMedia] = useState<Media[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [athleteRankings, setAthleteRankings] = useState<AthleteRanking[]>([]);
    const [showAdd, setShowAdd] = useState(false);

    useEffect(() => {
        Promise.all([
            getAthleteSingle(props.id),
            getAthleteRanking(props.id)
        ]).then((response: any) => {
            setAthlete(response[0].data);
            const newMedia = response[0].data.avatar.map((m: Media) => {
                return m;
            });
            setMedia(newMedia);
            setAthleteRankings(response[1].data);
            setLoaded(true);
        });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            athlete_id: athlete.id,
            ranking_date: event.target.ranking_date.value,
            points: event.target.points.value
        }
        createAthleteRanking(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    const newAthleteRankings = [
                        ...response.data.data,
                        ...athleteRankings
                    ];
                    setAthleteRankings(newAthleteRankings);
                    setShowAdd(false);
                } else {
                    alert(response.data.message);
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        const id = event.currentTarget.dataset.id;
        deleteAthleteRanking(id)
            .then(response => {
                const newAthleteRankings = athleteRankings.filter((r: AthleteRanking) => r.id != id);
                setAthleteRankings(newAthleteRankings);
            });
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAdd(true);
    }

    const handleCloseAddNew = (event: any) => {
        event.preventDefault();
        setShowAdd(false);
    }


    const CustomActions = (row: any) => (
        <span>
            {/*<a href="#" className="icon-link edit" title={ t("Edit") } onClick={ handleEdit } data-id={ row.row.id }>
                <i className="bi bi-pencil-square"></i>
            </a>*/}
            <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ row.row.id }>
                <i className="bi bi-trash"></i>
            </a>
        </span>
    );

    const CustomDate = (row: any ) => (
        <span>
            { moment(row.row.ranking_date).format("DD/MM/YYYY") }
        </span>
    );

    const columns = [
        {
            id: 'id',
            name: '#',
            style: { maxWidth: '80px' },
            selector: (row: any) => row.id,
            sortable: true
        },
        {
            id: 'ranking_date',
            name: t('ranking_date'),
            selector: (row: any) => row.athlete_name,
            sortable: true,
            cell: (row: any) => <CustomDate row={row} />,
        },
        {
            id: 'points',
            name: t('points_label'),
            selector: (row: any) => row.points,
            sortable: true
        },
        {
            id: 'actions',
            name: t("actions"),
            cell: (row: any) => <CustomActions row={row} />,
        }

    ];
    
    return (
        <Modal className="admin-athlete-ranking-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Athlete rankings") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { !loaded && 
                    <LoadingSpinner />
                }
                { loaded &&
                    <div className="athlete-rankings-container">
                        <div className="subtable-container">
                            <DataTable
                                columns={ columns }
                                data={athleteRankings}
                                // selectableRows={ true }
                                // selectableRowsHighlight={ true }
                                responsive={ true }
                                striped={ true }
                                highlightOnHover={ true }
                                defaultSortFieldId={ 'ranking_date' }
                                defaultSortAsc={ false }
                                pagination={ true }
                                customStyles={ tableStyles }
                                paginationComponentOptions={ getPaginationOptions() }
                            />
                        </div>
                        { !showAdd &&
                            <a className="ranking-add-new" href="#" onClick={ handleAddNew }>
                                <i className="bi bi-plus-circle"></i>
                            </a>
                        }
                        { showAdd && 
                            <Form onSubmit={ handleSave } className="add-ranking">
                                <a href="#" className="close" onClick={ handleCloseAddNew }>
                                </a>
                                <div className="fields">
                                    <Form.Control type="hidden" name="id" required defaultValue={ athlete.id } />
                                    <Form.Group className="mb-3" controlId="ranking_date">
                                        <Form.Label aria-required="true">{ t("ranking_date") }</Form.Label>
                                        <Form.Control type="date" name="ranking_date" required />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="points">
                                        <Form.Label aria-required="true">{ t("points_label") }</Form.Label>
                                        <Form.Control type="number" name="points" required />
                                    </Form.Group>
                                </div>
                                <div className="actions">
                                    <Button type="submit" variant="primary">
                                        { t("Save") }
                                    </Button>
                                    {/*<Button variant="secondary" onClick={ handleCloseAddNew }>
                                        { t("Close") }
                                    </Button>*/}
                                </div>
                            </Form>
                        }
                    </div>
                }
            </Modal.Body>
        </Modal>
    );
}